<script>
    import ListColumnToggle from './ListColumnToggle.svelte';
    export let displayOptions;
    export let toggleColumnDisplay;
    export let persistKey = null;
</script>

<style>
    .action-bar {
        display: flex;
        padding: 3px;
        background-color: #dee2e6;
    }
    
    .left-col {
        /* flex: 2; */
        margin-right: auto
    }

    .right-col {
        /* flex: 1; */
    }
</style>

<div class="action-bar">
    <div class="left-col"></div>
    <div class="right-col">
        <ListColumnToggle {displayOptions} {toggleColumnDisplay} {persistKey} />
    </div>
</div>